export default {
  cursor: {},
  current_index: 0,
}
